import React from 'react';
import PropTypes from 'prop-types';

// Check in the record if we can execute the specific action
// If not we will hide the menu item completely
const ConditionalMenu = ({ item, children: childs }) => {
  const children = React.Children.toArray(childs);
  const filtered = children.map(c => {
    const changedChildren = React.Children.toArray(c.props.children).filter(ch => {
      // If hidden prop is true, don't show
      if (ch.props.hidden) {
        return false;
      }
      // If the action has a state, only show if the item's activeState matches
      if (ch.props.state) {
        return item.activeState === ch.props.state;
      }
      // If no state specified, always show
      return true;
    });

    return React.cloneElement(c, { ...c.props, children: changedChildren });
  });

  return filtered.filter(f => React.Children.toArray(f.props.children).length > 0);
};

ConditionalMenu.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  item: PropTypes.object.isRequired,
};

export default ConditionalMenu;
